export var FormCategoryStatus;

(function (FormCategoryStatus) {
  FormCategoryStatus["Active"] = "active";
  FormCategoryStatus["Inactive"] = "inactive";
  FormCategoryStatus["Deleted"] = "deleted";
})(FormCategoryStatus || (FormCategoryStatus = {}));